import { useState } from "react";
import { Link } from "react-scroll";
import { FaBars, FaTimes } from "react-icons/fa";
import Logo from "../../assets/logo/logoblack.png";
import "./NavbarStyles.css";

const Navbar = () => {
  // Smooth State
  const closeMenu = () => setClick(false);

  // Hamburger State
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  // color State
  const [color, setColor] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 100) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  // Active Scroll Navbar
  window.addEventListener("scroll", changeColor);

  return (
    <div className={color ? "header header-bg" : "header"}>
      <Link to="/">
        <img className="logo" src={Logo} alt="logo" />
      </Link>
      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li>
          <Link
            className="nav-item"
            to="hero"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            onClick={closeMenu}
          >
            ACCUEIL
          </Link>
        </li>
        <li>
          <Link
            className="nav-item"
            to="news"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            onClick={closeMenu}
          >
            ACTUALITÉS
          </Link>
        </li>
        <li>
          <Link
            className="nav-item"
            to="production"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            onClick={closeMenu}
          >
            DISCOGRAPHIE
          </Link>
        </li>

        <li>
          <Link
            className="nav-item"
            to="about"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            onClick={closeMenu}
          >
            À PROPOS
          </Link>
        </li>
        <li>
          <Link
            className="nav-item"
            to="contact"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            onClick={closeMenu}
          >
            CONTACT
          </Link>
        </li>
      </ul>

      <div className="hamburger" onClick={handleClick}>
        {/* Si menu cliquÃ©, afficher page de fermeture */}
        {click ? (
          <FaTimes size={20} style={{ color: "fff" }} />
        ) : (
          // Sinon, afficher hamburger
          <FaBars size={20} style={{ color: "fff" }} />
        )}
      </div>
    </div>
  );
};

export default Navbar;
